module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "load-mask-parent"
  }, [_c('component-title', {
    attrs: {
      "config": _vm.config
    }
  }), _vm._v(" "), _c('div', {
    class: _vm.loadMask
  }), _vm._v(" "), _c('div', {
    ref: "my-map",
    staticStyle: {
      "height": "890px",
      "z-index": "0"
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-34e0c5c3!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/MapComponent.vue
// module id = 1265
// module chunks = 2